/* ==========================================================================
   31st — UI behaviour
   Vanilla, no dependencies. Every interaction degrades to working HTML.
   ========================================================================== */
(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  /* ---------------------------------------------------------------- utils */
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  window.st31 = window.st31 || {};

  window.st31.strings = (function () {
    var el = document.getElementById('st31-strings');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  /* ------------------------------------------------------------- drawers */
  var Drawer = {
    active: null,
    lastFocus: null,

    open: function (name) {
      var panel = document.querySelector('[data-st31-drawer="' + name + '"]');
      if (!panel) return;

      Drawer.lastFocus = document.activeElement;
      Drawer.active = panel;

      panel.setAttribute('data-open', 'true');
      panel.removeAttribute('aria-hidden');

      qsa('[data-st31-overlay]').forEach(function (o) { o.setAttribute('data-open', 'true'); });
      document.documentElement.style.overflow = 'hidden';

      qsa('[data-st31-drawer-open="' + name + '"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'true');
      });

      // Move focus inside so keyboard and screen-reader users land in the drawer
      window.requestAnimationFrame(function () {
        var target = panel.querySelector('[data-st31-autofocus]') || panel.querySelector(FOCUSABLE);
        if (target) target.focus();
      });
    },

    close: function () {
      var panel = Drawer.active;
      if (!panel) return;

      panel.setAttribute('data-open', 'false');
      panel.setAttribute('aria-hidden', 'true');

      qsa('[data-st31-overlay]').forEach(function (o) { o.setAttribute('data-open', 'false'); });
      document.documentElement.style.overflow = '';

      qsa('[aria-expanded="true"][data-st31-drawer-open]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
      });

      if (Drawer.lastFocus && document.contains(Drawer.lastFocus)) Drawer.lastFocus.focus();
      Drawer.active = null;
    },

    trap: function (e) {
      if (!Drawer.active || e.key !== 'Tab') return;
      var items = qsa(FOCUSABLE, Drawer.active).filter(function (el) {
        return el.offsetParent !== null;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  window.st31.Drawer = Drawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-st31-drawer-open]');
    if (opener) {
      e.preventDefault();
      Drawer.open(opener.getAttribute('data-st31-drawer-open'));
      return;
    }
    if (e.target.closest('[data-st31-drawer-close]') || e.target.closest('[data-st31-overlay]')) {
      e.preventDefault();
      Drawer.close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && Drawer.active) { Drawer.close(); return; }
    Drawer.trap(e);
  });

  /* ----------------------------------------------------------- accordions */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-st31-acc-trigger]');
    if (!trigger) return;

    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    var group = trigger.closest('[data-st31-acc][data-single="true"]');

    if (group && !isOpen) {
      qsa('[data-st31-acc-trigger]', group).forEach(function (t) {
        if (t === trigger) return;
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.setAttribute('data-open', 'false');
      });
    }

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.setAttribute('data-open', String(!isOpen));
  });

  /* ------------------------------------------------- sticky add-to-cart */
  /* The bar hides itself whenever the real product form is on screen, so it
     never sits on top of the control it duplicates. */
  function initStickyAtc() {
    var bar = document.querySelector('[data-st31-sticky-atc]');
    if (!bar) return;

    var anchor = document.querySelector('[data-st31-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) {
      bar.setAttribute('data-visible', 'true');
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.setAttribute('data-visible', entry.isIntersecting ? 'false' : 'true');
      });
    }, { rootMargin: '0px 0px -40% 0px' });

    observer.observe(anchor);
  }

  /* --------------------------------------------------------- quick add */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-st31-quick-add]');
    if (!form || !window.st31.cart) return;
    e.preventDefault();
    window.st31.cart.addFromForm(form);
  });

  /* ------------------------------------------------- announcement close */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-st31-dismiss]');
    if (!btn) return;
    var bar = btn.closest('[data-st31-announcement]');
    if (!bar) return;
    bar.hidden = true;
    try { sessionStorage.setItem('st31-announcement-dismissed', bar.dataset.st31Announcement || '1'); } catch (err) {}
  });

  function restoreAnnouncement() {
    var bar = document.querySelector('[data-st31-announcement]');
    if (!bar) return;
    try {
      if (sessionStorage.getItem('st31-announcement-dismissed') === (bar.dataset.st31Announcement || '1')) {
        bar.hidden = true;
      }
    } catch (err) {}
  }

  /* --------------------------------------------------------- sticky nav */
  function initStickyHeader() {
    var header = document.querySelector('[data-st31-header][data-sticky="true"]');
    if (!header) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.setAttribute('data-scrolled', y > 8 ? 'true' : 'false');
      last = y;
    }, { passive: true });
  }

  /* ------------------------------------------------ collection facets */
  /* Sorting and filters submit on change. Without JS the noscript button
     and plain checkboxes still work. */
  document.addEventListener('change', function (e) {
    var control = e.target.closest('[form="st31-facets"], #st31-sort');
    if (!control) return;
    var form = document.getElementById('st31-facets');
    if (!form) return;

    var params = new URLSearchParams();
    qsa('select, input', form).forEach(function (el) {
      if (el.type === 'checkbox' && !el.checked) return;
      if (!el.name || el.value === '') return;
      params.append(el.name, el.value);
    });
    qsa('input[type="checkbox"][form="st31-facets"]').forEach(function (el) {
      if (el.checked && el.name) params.append(el.name, el.value);
    });

    window.location.search = params.toString();
  });

  /* ------------------------------------------------------- marquee bar */
  /* Clones the message group until it overflows the viewport, then animates
     by exactly one group width so the loop is seamless. Duration is derived
     from a px/second speed, so the scroll rate stays the same no matter how
     much text the merchant adds. */
  function initMarquee(track) {
    var group = track.querySelector('[data-st31-marquee-group]');
    var viewport = track.parentElement;
    if (!group || !viewport) return;

    // Start clean so this can re-run on resize or a theme-editor reload
    qsa('.st31-announce__group', track).forEach(function (g) {
      if (g !== group) g.remove();
    });
    track.removeAttribute('data-ready');

    var groupWidth = group.getBoundingClientRect().width;
    var viewWidth = viewport.getBoundingClientRect().width;
    if (groupWidth < 1 || viewWidth < 1) return; // not laid out yet

    var copies = Math.max(2, Math.ceil(viewWidth / groupWidth) + 1);
    for (var i = 1; i < copies; i++) {
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-st31-marquee-group');
      qsa('a', clone).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      track.appendChild(clone);
    }

    var speed = parseFloat(track.getAttribute('data-speed')) || 45;
    track.style.setProperty('--st31-mq-width', groupWidth + 'px');
    track.style.setProperty('--st31-mq-duration', (groupWidth / speed).toFixed(2) + 's');
    track.setAttribute('data-ready', 'true');
  }

  function initMarquees() {
    qsa('[data-st31-marquee]').forEach(initMarquee);
  }

  var marqueeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(marqueeTimer);
    marqueeTimer = setTimeout(initMarquees, 200);
  }, { passive: true });

  function init() {
    initStickyAtc();
    initStickyHeader();
    restoreAnnouncement();
    initMarquees();

    // Web fonts change the measured width, so measure again once they land
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(initMarquees).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load
  document.addEventListener('shopify:section:load', init);
})();